import { type ApolloClient } from 'apollo-client';
import gql from 'graphql-tag';

export interface TenantContexts {
	cloudUrl: string;
}

const GET_BASE_URL = gql`
	query tenant_user_query($cloudIds: [ID!]) {
		tenantContexts(cloudIds: $cloudIds) {
			cloudUrl
		}
	}
`;

// Storing baseUrl in memory here so that it can be reused across all extension points for all apps.
// Only called once per session or full page reload
let storedBaseUrl = '';

// Retrieves the Atlassian base url for a given cloudId
export const getBaseUrl = async (
	client: ApolloClient<any>,
	cloudId: string,
): Promise<string | null> => {
	if (storedBaseUrl) {
		return storedBaseUrl;
	}

	if (cloudId) {
		const response = await client.query<{ tenantContexts: Array<TenantContexts> }>({
			query: GET_BASE_URL,
			variables: {
				cloudIds: cloudId,
			},
		});

		const baseUrl = response.data?.tenantContexts?.[0].cloudUrl;
		storedBaseUrl = baseUrl;
		return baseUrl;
	}
	return null;
};
